import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import Link from '@components/primitives/Link'
import { MediaCard } from '@components/primitives/MediaCard'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { Gradients } from '@lib/colors/colors'
import type { Url } from '@lib/routes'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import TreatmentTopicCategoryCardWrapper from './TreatmentTopicCategoryCardWrapper.client'

interface TreatmentTopicCategoryCardProps {
  backgroundGradient?: Gradients
  description?: string
  href: Url
  icon: IconDefinition
  index: number
  slug: string
  subtitle: string
  trackingSource: TrackingSources
}

const TREATMENT_IMAGES = [
  '2ee51b83-87b7-42c6-321a-f0f18e9d2200',
  '69f45556-a5dd-4c1a-e5ed-dfa0a17c4c00',
  'ac13adbc-7c9c-4ff6-c046-ff0cea29fe00',
  '3689363c-f367-49c0-ab2f-2cfbf8ff5f00',
  'c33fff02-9ce6-4530-4de4-bb14489b7d00',
  '08370f64-5543-45b1-3e16-14a1f0049e00',
  'f682926d-0b4a-4250-1ebf-bac7ced7e800',
  '052173f2-b84b-4210-ed46-b29b54bbc200',
  '51e2329f-2cd1-469d-ed91-3eae16b07e00',
  '2c1643a1-f566-475c-7d9b-685e53e22e00',
]

/** The section immediately below the home page's hero. **/
export function TreatmentTopicCategoryCard({
  description,
  href,
  icon,
  index,
  subtitle,
  trackingSource,
}: TreatmentTopicCategoryCardProps) {
  return (
    <TreatmentTopicCategoryCardWrapper
      path={href.toString()}
      source={trackingSource}
    >
      <Link href={href}>
        <MediaCard
          className='border border-neutral200'
          desc={subtitle}
          icon={icon}
          subtitle={description!}
        >
          <CloudflareImage
            alt={description!}
            className='w-full rounded-t-lg'
            height={200}
            imageId={TREATMENT_IMAGES[index % TREATMENT_IMAGES.length]!}
            width={300}
          />
        </MediaCard>
      </Link>
    </TreatmentTopicCategoryCardWrapper>
  )
}
